module.exports = __webpack_public_path__ + "media/images/lb/208-c83be1f8c1cd5321d939814111e71bfb.svg";